<template>
  <v-app>
    <v-toolbar app height="45" class="col-xs-12" flat fixed>
      <div class="col-xs-7 col-md-7" style="padding:0px;">
        <h3>Register</h3>
      </div>
    </v-toolbar>
    <v-container grid-list-md style="padding:10px;margin-top:45px;">
      <!-- //Company info -->
      <h4>
        <strong>Company Info :</strong>
      </h4>
      <v-card style="background-color:#F4B95F;">
        <v-card-text style="padding:10px;">
          <v-layout wrap>
            <!-- Merchant Code -->
            <v-flex xs12>
              <h4 class="rTitle">Url :</h4>
              <v-layout>
                <h4
                  v-if="globalVar.state == 'live'"
                  class="rTitle"
                  style="width:230px;margin:auto;padding-left:4px;"
                >
                  <span style="color:red;">*</span>https://order.mpos.us/
                </h4>
                <h4
                  v-if="globalVar.state == 'test'"
                  class="rTitle"
                  style="width:230px;margin:auto;padding-left:4px;"
                >
                  <span style="color:red;">*</span>https://testweb.mpos.us/
                </h4>
                <input
                  type="text"
                  class="form-control"
                  name="rMchdCode"
                  maxlength="20"
                  minlength="4"
                  autocomplete="nope"
                  @input="rMchdCode = $event.target.value"
                />
              </v-layout>
            </v-flex>

            <!-- Merchant Name -->
            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Title :
              </h4>
              <input
                type="text"
                class="form-control"
                name="rMchdName"
                autocomplete="nope"
                @input="rMchdName = $event.target.value"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Company Name :
              </h4>
              <input
                type="text"
                class="form-control"
                name="rCpyName"
                autocomplete="nope"
                @input="rCpyName = $event.target.value"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Contact Number :
              </h4>
              <input
                v-model="rPhNo"
                type="tel"
                style="width:100%;"
                class="form-control"
                name="rPhNo"
                autocomplete="nope"
                @input="rPhNo = $event.target.value.replace(/[^0-9]/g,'')"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Address :
              </h4>
              <textarea
                type="text"
                rows="5"
                class="form-control"
                name="rAddress"
                autocomplete="nope"
                @input="rAddress = $event.target.value"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">Agent Code :</h4>
              <input
                v-if="urGetAgCode"
                v-model="rAgentCode"
                type="text"
                class="form-control"
                name="rAgentCode"
                autocomplete="nope"
                readonly
                @input="rAgentCode = $event.target.value"
              />
              <input
                v-if="urGetAgCode == false"
                type="text"
                class="form-control"
                name="rAgentCode"
                autocomplete="nope"
                @input="rAgentCode = $event.target.value"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- //user info -->
      <br />
      <h4>
        <strong>Login Info :</strong>
      </h4>
      <v-card style="background-color:#F4B95F;">
        <v-card-text style="padding:10px;">
          <v-layout wrap>
            <!-- <v-flex xs12>
              <h4 class="rTitle">User Name :</h4>

              <input
                type="text"
                class="form-control"
                name="rUserName"
                autocomplete="nope"
                @input="rUserName = $event.target.value"
              />
            </v-flex>-->

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Email :
              </h4>
              <input
                type="email"
                class="form-control"
                name="rEmail"
                autocomplete="nope"
                @input="rEmail = $event.target.value"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Password :
              </h4>
              <input
                type="password"
                class="form-control"
                name="rPassword"
                autocomplete="nope"
                @input="rPassword = $event.target.value"
              />
            </v-flex>

            <v-flex xs12>
              <h4 class="rTitle">
                <span style="color:red;">*</span>Confirm Password :
              </h4>
              <input
                type="password"
                class="form-control"
                name="crPassword"
                autocomplete="nope"
                @input="crPassword = $event.target.value"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <p style="color:red;font-size:16px;margin-top:5px;">* Required Fields</p>
      <p v-if="regError != ''" class="errorMsg">{{regError}}</p>
      <button
        type="submit"
        class="btn btn-primary"
        style="width:50%;float:right;margin-top: 15px; margin-bottom: 15px;"
        @click="checkRegisterInfo()"
      >Register</button>
    </v-container>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">{{$t('InProgressPleaseWaitAMoment')}}</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError" :key="componentKey"></VersionDialog>
  </v-app>
</template>

<script>
import JS from './JsonService'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
export default {
  components: {
    VersionDialog
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['agCode'],
  data() {
    return {
      rCpyName: '',
      rEmail: '',
      rPhNo: '',
      rAddress: '',
      rMchdCode: '',
      rMchdName: '',
      // rUserName: '',
      rAgentCode: '',
      rPassword: '',
      crPassword: '',
      regError: '',
      versionError: false,
      componentKey: 0,
      sendRefId: '',
      loadingDialog: false,
      urGetAgCode: false,
      globalVar: globalVar
    }
  },
  created: function() {
    if (this.agCode != '' && this.agCode != undefined && this.agCode != null) {
      this.rAgentCode = this.agCode
      this.urGetAgCode = true
    } else {
      this.urGetAgCode = false
    }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    checkRegisterInfo() {
      this.loadingDialog = true
      this.regError = ''
      if (
        this.rMchdCode == '' ||
        this.rMchdCode == undefined ||
        this.rMchdCode == null
      ) {
        this.regError = 'Url cannot be empty'
        this.loadingDialog = false
      } else {
        if (!this.rMchdCode.match(/^[a-z0-9]+$/i)) {
          this.regError = 'URL must only use a-z, A-Z, 0-9, and no spaces'
          this.loadingDialog = false
        } else {
          if (this.rMchdCode.length < 4) {
            this.regError = 'URL must be at least 4 characters'
            this.loadingDialog = false
          } else {
            if (
              this.rMchdName.trim() == '' ||
              this.rMchdName.trim() == undefined ||
              this.rMchdName.trim() == null
            ) {
              this.regError = 'Title cannot be empty'
              this.loadingDialog = false
            } else {
              if (
                this.rCpyName.trim() == '' ||
                this.rCpyName.trim() == undefined ||
                this.rCpyName.trim() == null
              ) {
                this.regError = 'Company Name cannot be empty'
                this.loadingDialog = false
              } else {
                if (
                  this.rPhNo.trim() == '' ||
                  this.rPhNo.trim() == undefined ||
                  this.rPhNo.trim() == null
                ) {
                  this.regError = 'Contact Number cannot be empty'
                  this.loadingDialog = false
                } else {
                  this.rPhNo = this.rPhNo.trim()
                  if (this.rPhNo.length < 8) {
                    this.regError =
                      'Contact Number must be at least 8 characters'
                    this.loadingDialog = false
                  } else {
                    if (
                      this.rAddress.trim() == '' ||
                      this.rAddress.trim() == undefined ||
                      this.rAddress.trim() == null
                    ) {
                      this.regError = 'Address cannot be empty'
                      this.loadingDialog = false
                    } else {
                      if (
                        this.rEmail.trim() == '' ||
                        this.rEmail.trim() == undefined ||
                        this.rEmail.trim() == null
                      ) {
                        this.regError = 'Email must be a valid email address'
                        this.loadingDialog = false
                      } else if (this.rEmail.trim() != '') {
                        if (!this.validEmail(this.rEmail.trim())) {
                          this.regError = 'Email must be a valid email address'
                          this.loadingDialog = false
                        } else {
                          if (
                            this.rPassword.trim() == '' ||
                            this.rPassword.trim() == undefined ||
                            this.rPassword.trim() == null
                          ) {
                            this.regError = 'Password cannot be empty'
                            this.loadingDialog = false
                          } else {
                            if (
                              this.crPassword.trim() == '' ||
                              this.crPassword.trim() == undefined ||
                              this.crPassword.trim() == null
                            ) {
                              this.regError = 'Confirm Password cannot be empty'
                              this.loadingDialog = false
                            } else {
                              if (this.crPassword != this.rPassword) {
                                this.regError = 'Inconsistent Password'
                                this.loadingDialog = false
                              } else {
                                this.regError = ''
                                this.register()
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    validEmail: function(email) {
      //eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    register() {
      this.versionError = false
      this.sendRefId = new Date().getTime()
      var version = sessionStorage.getItem('version')
      const url = 'Back/RegMcht'
      const parameter = {
        av: version,
        kp: this.rMchdCode,
        ff: this.rMchdName,
        oz: this.rCpyName,
        ly: this.rEmail,
        az: this.rPhNo,
        en: this.rAddress,
        // x: this.rUserName,
        on: this.rPassword,
        ey: this.sendRefId,
        rr: this.rAgentCode
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.loadingDialog = false
            this.componentKey += 1
            this.versionError = true
          } else {
            this.sendRefId = ''
            this.versionError = false
            if (response.data.ht == 'Success') {
              this.loadingDialog = false
              sessionStorage.setItem('paramMchdCode', this.rMchdCode)
              sessionStorage.setItem(
                'fromRegister',
                JSON.stringify({
                  mchCode: this.rMchdCode,
                  name: this.rEmail,
                  pwd: this.rPassword
                })
              )
              this.$router.replace({
                name: 'Back',
                params: { mchdCode: this.rMchdCode }
              })
            } else {
              this.regError = response.data
              this.loadingDialog = false
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.regError = error
          this.versionError = false
          this.loadingDialog = false
        })
    }
  }
}
</script>

<style>
.errorMsg {
  margin: var(--register-errorMsg-margin);
  margin-top: var(--register-errorMsg-margin_top);
  color: var(--register-errorMsg-color);
  font-size: var(--register-errorMsg-font_size);
}

h4 {
  text-align: var(--register-h4-text_align);
}
.rTitle {
  font-size: 16px;
}
.col-md-6 {
  background-color: var(--register-col_md_6-background_color);
  border-radius: var(--register-col_md_6-border_radius);
}

@media (max-width: 550px) {
  button.btn {
    padding-left: var(--register-mediaMax550-button_btn-padding_left);
    padding-right: var(--register-mediaMax550-button_btn-padding_right);
  }

  .errorMsg {
    margin: var(--register-mediaMax550-errorMsg-margin);
    margin-top: var(--register-mediaMax550-errorMsg-margin_top);
    color: var(--register-mediaMax550-errorMsg-color);
    font-size: var(--register-mediaMax550-errorMsg-font_size);
    margin-left: var(--register-mediaMax550-errorMsg-margin_left);
    margin-right: var(--register-mediaMax550-errorMsg-margin_right);
  }
}
</style>
